import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	root: {
		border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
		borderRadius: tokens.borderRadiusMedium,
	},
	buttonsContainer: {
		height: "42px",
		maxWidth: "250px",
	},
	icon: {
		flexShrink: 0,
		marginLeft: "2px",
	},
	middleContainer: {
		overflow: "hidden",
	},
	button: {
		border: "none",
		padding: "4px",
		overflow: "hidden",
		backgroundColor: "inherit",
		cursor: "pointer",

		"&:hover": {
			backgroundColor: tokens.colorNeutralStroke2,
		},
	},
	buttonMenu: {
		flexShrink: 0,
	},
	progressBar: {
		transition: "opacity 0.8s ease",
		opacity: 1,
	},

	progressBarHidden: {
		opacity: 0,
		height: 0,
	},
});

export const useListStyle = makeStyles({
	root: {
		maxWidth: "250px",
		overflow: "hidden",
	},
	container: {
		overflow: "hidden",
		borderBottom: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
		"&:last-child": {
			border: "none",
		},
	},
	midContainer: {
		overflow: "hidden",
	},
	button: {
		padding: "6px",
		border: "none",
		backgroundColor: "inherit",
		color: tokens.colorNeutralForeground1,
		cursor: "pointer",
		height: "100%",

		"&:hover": {
			backgroundColor: tokens.colorNeutralBackground1Hover,
		},
	},
	primaryButton: {
		overflow: "hidden",
		flexGrow: 1,
		width: "218px",
	},
	popoverTrigger: {
		color: tokens.colorNeutralForeground1,
	},
});
